// src/components/SeoHelmet.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { buildHelmetData } from '../lib/seo';

const DEFAULT_TITLE = "Kangaroo Care: Women & Children Hospitals";
const DEFAULT_DESCRIPTION = "Kangaroo Care Hospital is Bangalore's most trusted Women and Child Care Hospital providing premier quality and high standard healthcare to every mother and child.";
const DEFAULT_KEYWORDS = "Best Gynaecology Hospital in Bangalore, Best Child Care Hospital in Bangalore, Pregnancy Care Hospital in Vijayanagar, Bangalore, Best Pediatric Hospital in Vijayanagar, Bangalore";

export default function SeoHelmet({ seo }) {
  const helmetData = buildHelmetData(seo);

  if (!helmetData) {
    // Graceful fallback if API fails or returns null
    return (
      <Helmet>
        <title>{DEFAULT_TITLE}</title>
        <meta name="description" content={DEFAULT_DESCRIPTION} />
        <meta name="keywords" content={DEFAULT_KEYWORDS} />
        <meta name="robots" content="index, follow" />
      </Helmet>
    );
  }

  return (
    <Helmet>
      {/* Title */}
      <title>{helmetData.title || DEFAULT_TITLE}</title>

      {/* Primary Meta Tags */}
      {helmetData.description ? (
        <meta name="description" content={helmetData.description} />
      ) : (
        <meta name="description" content={DEFAULT_DESCRIPTION} />
      )}
      
      {helmetData.keywords ? (
        <meta name="keywords" content={helmetData.keywords} />
      ) : (
        <meta name="keywords" content={DEFAULT_KEYWORDS} />
      )}

      {helmetData.robots && <meta name="robots" content={helmetData.robots} />}
      
      {/* Canonical Link */}
      {helmetData.canonical && <link rel="canonical" href={helmetData.canonical} />}

      {/* Open Graph Tags */}
      {helmetData.openGraph?.title && <meta property="og:title" content={helmetData.openGraph.title} />}
      {helmetData.openGraph?.description && <meta property="og:description" content={helmetData.openGraph.description} />}
      {helmetData.openGraph?.type && <meta property="og:type" content={helmetData.openGraph.type} />}
      {helmetData.openGraph?.url && <meta property="og:url" content={helmetData.openGraph.url} />}
      {helmetData.openGraph?.siteName && <meta property="og:site_name" content={helmetData.openGraph.siteName} />}
      {helmetData.openGraph?.image && <meta property="og:image" content={helmetData.openGraph.image} />}
      {helmetData.openGraph?.imageAlt && <meta property="og:image:alt" content={helmetData.openGraph.imageAlt} />}

      {/* Twitter Tags */}
      {helmetData.twitter?.card && <meta name="twitter:card" content={helmetData.twitter.card} />}
      {helmetData.twitter?.title && <meta name="twitter:title" content={helmetData.twitter.title} />}
      {helmetData.twitter?.description && <meta name="twitter:description" content={helmetData.twitter.description} />}
      {helmetData.twitter?.site && <meta name="twitter:site" content={helmetData.twitter.site} />}
      {helmetData.twitter?.creator && <meta name="twitter:creator" content={helmetData.twitter.creator} />}
      {helmetData.twitter?.image && <meta name="twitter:image" content={helmetData.twitter.image} />}
      {helmetData.twitter?.imageAlt && <meta name="twitter:image:alt" content={helmetData.twitter.imageAlt} />}
    </Helmet>
  );
}
